import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { TranslationService } from '../../services/translation.service';
import {
  actionCountriesListGet,
  actionCountriesListGetSuccess,
} from './countries.actions';
import * as i18nIsoCountries from 'i18n-iso-countries';
import { exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CountriesEffects {
  constructor(
    private translationService: TranslationService,
    private actions$: Actions
  ) {}

  getCountriesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actionCountriesListGet),
      exhaustMap(() => {
        let currentLang = this.translationService.getCurrentLocaleISO_639Code();

        i18nIsoCountries.registerLocale(
          require(`i18n-iso-countries/langs/${currentLang}.json`)
        );

        return of(
          actionCountriesListGetSuccess({
            payload: {
              countriesList: i18nIsoCountries.getNames(currentLang, {
                select: 'official',
              }),
            },
          })
        );
      })
    )
  );
}
